import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "The Jeddah Corniche Circuit is home to the FORMULA 1 STC SAUDI ARABIAN GRAND PRIX. Hosting its inaugural event in 2021, the world-class motorsport facility was constructed in a record time of just seven months and is the first of its kind in the Kingdom, achieving the required Grade 1 FIA standards to host an F1 event."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "In terms of length, the Tilke-designed circuit, measures 6.176 kilometers and is the fastest and longest street circuit on the current F1 calendar. Its many high-speed corners - there are 27 in total (16 left, 11 right) - make it a favorite of both drivers and fans."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "To date it has hosted four spectacular Formula 1 race weekends, which have each produced a different winner and confirmed the track as the world’s fastest street circuit, with drivers clocking up average speeds of 252km/h."
    }), "\n", _jsx("br", {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
